import { render, staticRenderFns } from "./PriceCalc.vue?vue&type=template&id=4d445227&scoped=true&"
import script from "./PriceCalc.vue?vue&type=script&lang=js&"
export * from "./PriceCalc.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalc.vue?vue&type=style&index=0&id=4d445227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d445227",
  null
  
)

export default component.exports